const languages = [
  {
    Nombre: "Abkhaz",
    cod: "ab",
  },
  {
    Nombre: "Afar",
    cod: "aa",
  },
  {
    Nombre: "Africanos",
    cod: "af",
  },
  {
    Nombre: "Akan",
    cod: "ak",
  },
  {
    Nombre: "Albania",
    cod: "sq",
  },
  {
    Nombre: "Amárico",
    cod: "am",
  },
  {
    Nombre: "Árabe",
    cod: "ar",
  },
  {
    Nombre: "Aragonés",
    cod: "an",
  },
  {
    Nombre: "Armenio",
    cod: "hy",
  },
  {
    Nombre: "Assamese",
    cod: "as",
  },
  {
    Nombre: "Avaric",
    cod: "av",
  },
  {
    Nombre: "Avestan",
    cod: "ae",
  },
  {
    Nombre: "Aymara",
    cod: "ay",
  },
  {
    Nombre: "Azerbaiyán",
    cod: "az",
  },
  {
    Nombre: "Bambara",
    cod: "bm",
  },
  {
    Nombre: "Bashkir",
    cod: "ba",
  },
  {
    Nombre: "Vasco",
    cod: "eu",
  },
  {
    Nombre: "Belarús",
    cod: "be",
  },
  {
    Nombre: "Bengalí",
    cod: "bn",
  },
  {
    Nombre: "Bihari",
    cod: "bh",
  },
  {
    Nombre: "Bislama",
    cod: "bi",
  },
  {
    Nombre: "Bosnia",
    cod: "bs",
  },
  {
    Nombre: "Breton",
    cod: "br",
  },
  {
    Nombre: "Búlgaro",
    cod: "bg",
  },
  {
    Nombre: "Burmese",
    cod: "my",
  },
  {
    Nombre: "Catalán",
    cod: "ca",
  },
  {
    Nombre: "Chamorro",
    cod: "ch",
  },
  {
    Nombre: "Chechenio",
    cod: "ce",
  },
  {
    Nombre: "Chichewa, Chewa, Nyanja",
    cod: "ny",
  },
  {
    Nombre: "Chino",
    cod: "zh",
  },
  {
    Nombre: "Chuvashia",
    cod: "cv",
  },
  {
    Nombre: "Cornualles",
    cod: "kw",
  },
  {
    Nombre: "Corso",
    cod: "co",
  },
  {
    Nombre: "Cree",
    cod: "cr",
  },
  {
    Nombre: "Croacia",
    cod: "hr",
  },
  {
    Nombre: "Checo",
    cod: "cs",
  },
  {
    Nombre: "Danés",
    cod: "da",
  },
  {
    Nombre: "Divehi, Dhivehi, Maldivas",
    cod: "dv",
  },
  {
    Nombre: "Holandés",
    cod: "nl",
  },
  {
    Nombre: "Dzongkha",
    cod: "dz",
  },
  {
    Nombre: "Inglés",
    cod: "en",
  },
  {
    Nombre: "Esperanto",
    cod: "eo",
  },
  {
    Nombre: "Estonia",
    cod: "et",
  },
  {
    Nombre: "Ewe",
    cod: "ee",
  },
  {
    Nombre: "Faroese",
    cod: "fo",
  },
  {
    Nombre: "Fiji",
    cod: "fj",
  },
  {
    Nombre: "Finlandés",
    cod: "fi",
  },
  {
    Nombre: "Francés",
    cod: "fr",
  },
  {
    Nombre: "Fula, Fulah, Pulaar, Pular",
    cod: "ff",
  },
  {
    Nombre: "Galicia",
    cod: "gl",
  },
  {
    Nombre: "Georgiano",
    cod: "ka",
  },
  {
    Nombre: "Alemán",
    cod: "de",
  },
  {
    Nombre: "Griego Moderno",
    cod: "el",
  },
  {
    Nombre: "Guaraní",
    cod: "gn",
  },
  {
    Nombre: "Gujarati",
    cod: "gu",
  },
  {
    Nombre: "Haitiano, creole haitiano",
    cod: "ht",
  },
  {
    Nombre: "Hausa",
    cod: "ha",
  },
  {
    Nombre: "Hebreo (moderno)",
    cod: "he",
  },
  {
    Nombre: "Herero",
    cod: "hz",
  },
  {
    Nombre: "Hindi",
    cod: "hi",
  },
  {
    Nombre: "Hiri Motu",
    cod: "ho",
  },
  {
    Nombre: "Húngaro",
    cod: "hu",
  },
  {
    Nombre: "Interlingua",
    cod: "ia",
  },
  {
    Nombre: "Indonesio",
    cod: "id",
  },
  {
    Nombre: "Interlingue",
    cod: "ie",
  },
  {
    Nombre: "Irlanda",
    cod: "ga",
  },
  {
    Nombre: "Igbo",
    cod: "ig",
  },
  {
    Nombre: "Inupiaq",
    cod: "ik",
  },
  {
    Nombre: "Ido",
    cod: "io",
  },
  {
    Nombre: "Islandés",
    cod: "is",
  },
  {
    Nombre: "Italiano",
    cod: "it",
  },
  {
    Nombre: "Inuktitut",
    cod: "iu",
  },
  {
    Nombre: "Japonés",
    cod: "ja",
  },
  {
    Nombre: "Javanés",
    cod: "jv",
  },
  {
    Nombre: "Kalaallisut, Groenlandia",
    cod: "kl",
  },
  {
    Nombre: "Canarés",
    cod: "kn",
  },
  {
    Nombre: "Kanuri",
    cod: "kr",
  },
  {
    Nombre: "Cachemira",
    cod: "ks",
  },
  {
    Nombre: "Kazajstán",
    cod: "kk",
  },
  {
    Nombre: "Khmer",
    cod: "km",
  },
  {
    Nombre: "Kikuyu, Gikuyu",
    cod: "ki",
  },
  {
    Nombre: "Kinyarwanda",
    cod: "rw",
  },
  {
    Nombre: "Kirguises, Kirguistán",
    cod: "ky",
  },
  {
    Nombre: "Komi",
    cod: "kv",
  },
  {
    Nombre: "Kongo",
    cod: "kg",
  },
  {
    Nombre: "Corea",
    cod: "ko",
  },
  {
    Nombre: "Kurdo",
    cod: "ku",
  },
  {
    Nombre: "Kwanyama, Kuanyama",
    cod: "kj",
  },
  {
    Nombre: "Latin",
    cod: "la",
  },
  {
    Nombre: "Luxemburgués, Luxemburgués",
    cod: "lb",
  },
  {
    Nombre: "Luganda",
    cod: "lg",
  },
  {
    Nombre: "Limburgués, Limburgan, Limburger",
    cod: "li",
  },
  {
    Nombre: "Lingala",
    cod: "ln",
  },
  {
    Nombre: "Lao",
    cod: "lo",
  },
  {
    Nombre: "Lituano",
    cod: "lt",
  },
  {
    Nombre: "Luba-Katanga",
    cod: "lu",
  },
  {
    Nombre: "Letonia",
    cod: "lv",
  },
  {
    Nombre: "Manx",
    cod: "gv",
  },
  {
    Nombre: "Macedonia",
    cod: "mk",
  },
  {
    Nombre: "Madagascar",
    cod: "mg",
  },
  {
    Nombre: "Malayo",
    cod: "ms",
  },
  {
    Nombre: "Malayalam",
    cod: "ml",
  },
  {
    Nombre: "Maltés",
    cod: "mt",
  },
  {
    Nombre: "Māori",
    cod: "mi",
  },
  {
    Nombre: "Maratí (Marathi)",
    cod: "mr",
  },
  {
    Nombre: "De las Islas Marshall",
    cod: "mh",
  },
  {
    Nombre: "Mongolia",
    cod: "mn",
  },
  {
    Nombre: "Nauru",
    cod: "na",
  },
  {
    Nombre: "Navajo, Navaho",
    cod: "nv",
  },
  {
    Nombre: "Noruego Bokmål",
    cod: "nb",
  },
  {
    Nombre: "Ndebele del Norte",
    cod: "nd",
  },
  {
    Nombre: "Nepali",
    cod: "ne",
  },
  {
    Nombre: "Ndonga",
    cod: "ng",
  },
  {
    Nombre: "Noruego Nynorsk",
    cod: "nn",
  },
  {
    Nombre: "Noruego",
    cod: "no",
  },
  {
    Nombre: "Nuosu",
    cod: "ii",
  },
  {
    Nombre: "Ndebele del sur",
    cod: "nr",
  },
  {
    Nombre: "Occitano",
    cod: "oc",
  },
  {
    Nombre: "Ojibwe, Ojibwa",
    cod: "oj",
  },
  {
    Nombre:
      "Antiguo eslavo eclesiástico, Iglesia eslava, eslavo eclesiástico, antiguo Búlgaro, Esclavo viejo",
    cod: "cu",
  },
  {
    Nombre: "Oromo",
    cod: "om",
  },
  {
    Nombre: "Oriya",
    cod: "or",
  },
  {
    Nombre: "Osetia del Sur, osetio",
    cod: "os",
  },
  {
    Nombre: "Panjabi, Punjabi",
    cod: "pa",
  },
  {
    Nombre: "Pāli",
    cod: "pi",
  },
  {
    Nombre: "Persa",
    cod: "fa",
  },
  {
    Nombre: "Polaco",
    cod: "pl",
  },
  {
    Nombre: "Pashto, Pushto",
    cod: "ps",
  },
  {
    Nombre: "Portugués",
    cod: "pt",
  },
  {
    Nombre: "Quechua",
    cod: "qu",
  },
  {
    Nombre: "Romanche",
    cod: "rm",
  },
  {
    Nombre: "Kirundi",
    cod: "rn",
  },
  {
    Nombre: "Rumania, Moldavia, Moldavan",
    cod: "ro",
  },
  {
    Nombre: "Ruso",
    cod: "ru",
  },
  {
    Nombre: "Sánscrito (samskrta)",
    cod: "sa",
  },
  {
    Nombre: "Sardo",
    cod: "sc",
  },
  {
    Nombre: "Sindhi",
    cod: "sd",
  },
  {
    Nombre: "Sami del norte",
    cod: "se",
  },
  {
    Nombre: "Samoa",
    cod: "sm",
  },
  {
    Nombre: "Sango",
    cod: "sg",
  },
  {
    Nombre: "Serbio",
    cod: "sr",
  },
  {
    Nombre: "Gaélico escocés, gaélico",
    cod: "gd",
  },
  {
    Nombre: "Shona",
    cod: "sn",
  },
  {
    Nombre: "Cingalés, singalés",
    cod: "si",
  },
  {
    Nombre: "Eslovaca",
    cod: "sk",
  },
  {
    Nombre: "Esloveno",
    cod: "sl",
  },
  {
    Nombre: "Somalí",
    cod: "so",
  },
  {
    Nombre: "Southern Sotho",
    cod: "st",
  },
  {
    Nombre: "Español, castellano",
    cod: "es",
  },
  {
    Nombre: "Sundanese",
    cod: "su",
  },
  {
    Nombre: "Swahili",
    cod: "sw",
  },
  {
    Nombre: "Swati",
    cod: "ss",
  },
  {
    Nombre: "Sueco",
    cod: "sv",
  },
  {
    Nombre: "Tamil",
    cod: "ta",
  },
  {
    Nombre: "Telugu",
    cod: "te",
  },
  {
    Nombre: "Tayikistán",
    cod: "tg",
  },
  {
    Nombre: "Tailandia",
    cod: "th",
  },
  {
    Nombre: "Tigrinya",
    cod: "ti",
  },
  {
    Nombre: "Tibetano estándar, Tibetano, Central",
    cod: "bo",
  },
  {
    Nombre: "Turkmenistán",
    cod: "tk",
  },
  {
    Nombre: "Tagalo",
    cod: "tl",
  },
  {
    Nombre: "Tswana",
    cod: "tn",
  },
  {
    Nombre: "Tonga (Islas Tonga)",
    cod: "to",
  },
  {
    Nombre: "Turco",
    cod: "tr",
  },
  {
    Nombre: "Tsonga",
    cod: "ts",
  },
  {
    Nombre: "Tártara",
    cod: "tt",
  },
  {
    Nombre: "Twi",
    cod: "tw",
  },
  {
    Nombre: "Tahitian",
    cod: "ty",
  },
  {
    Nombre: "Uighur, Uyghur",
    cod: "ug",
  },
  {
    Nombre: "Ucrania",
    cod: "uk",
  },
  {
    Nombre: "Urdu",
    cod: "ur",
  },
  {
    Nombre: "Uzbeko",
    cod: "uz",
  },
  {
    Nombre: "Venda",
    cod: "ve",
  },
  {
    Nombre: "Vietnamita",
    cod: "vi",
  },
  {
    Nombre: "Volapük",
    cod: "vo",
  },
  {
    Nombre: "Valonia",
    cod: "wa",
  },
  {
    Nombre: "Galés",
    cod: "cy",
  },
  {
    Nombre: "Wolof",
    cod: "wo",
  },
  {
    Nombre: "Oeste de Frisia",
    cod: "fy",
  },
  {
    Nombre: "Xhosa",
    cod: "xh",
  },
  {
    Nombre: "Yiddish",
    cod: "yi",
  },
  {
    Nombre: "Yoruba",
    cod: "yo",
  },
  {
    Nombre: "Zhuang, Chuang",
    cod: "za",
  },
  {
    Nombre: "Zulu",
    cod: "zu",
  },
];
export default languages;
